module.exports = __webpack_public_path__ + "static/img/option-3.88b064bf.png";